import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M17.804 4.069L13.61 2.458C12.815 2.153 12.417 2 12 2s-.815.153-1.61.458l-4.194 1.61C4.066 4.888 3 5.297 3 6s1.065 1.113 3.196 1.931l4.195 1.611c.794.305 1.192.458 1.609.458s.815-.153 1.61-.458l4.194-1.61C19.934 7.112 21 6.703 21 6s-1.065-1.113-3.196-1.931" }),
      _createElementVNode("path", { d: "M21 6v12c0 .704-1.065 1.113-3.196 1.931l-4.195 1.611c-.794.305-1.192.458-1.609.458s-.815-.153-1.61-.458l-4.194-1.61C4.066 19.112 3 18.703 3 18V6m9 4v12" }),
      _createElementVNode("path", { d: "M16.5 4L7 8v2.5m-1.5 5.592v-.836c0-.696 0-1.043.225-1.194c.225-.15.54-.013 1.169.26l1.5.653c.294.128.44.192.523.319s.083.29.083.614v.836c0 .696 0 1.044-.225 1.194s-.54.013-1.169-.26l-1.5-.653c-.294-.128-.44-.192-.523-.319s-.083-.29-.083-.614" })
    ], -1)
  ]))]))
}
export default { render: render }